import { Message, MessageGroup } from '../../plugins/api'
import moment from 'moment'
import axios from '@/plugins/axios'
const UPLOAD_API = '/upload/'

export default {
  namespaced: true,
  state: {
    messageGroups: [],
    messages: [],
    messageGroup: {},
    groupNo: 0,
    loading: false,
    messageLoading: false
  },
  actions: {
    async fetchMessageGroups({ commit }, query) {
      commit('changeState', { loading: true })

      const params = {
        ...query,
        _sort: 'lastMessageTime:desc',
        _limit: (query && query['_limit']) || 15
      }

      const [messageGroups, groupNo] = await Promise.all([MessageGroup.fetch(params), MessageGroup.count(params)])
      commit('changeState', { messageGroups, groupNo, loading: false })
    },
    async fetchMessages({ commit }, group) {
      commit('changeState', { messageLoading: !group.isSameId })
      const messages = await Message.fetch({ messageGroup: group.id, _limit: -1 })
      commit('changeState', { messages, messageGroup: group, messageLoading: false })
      // update scholl Side Last Seen
      MessageGroup.update(group.id, {
        schollSideLastSeen: moment().toISOString()
      })
    },
    async createMessage({ commit, state }, message) {
      const m = await Message.create(message)
      MessageGroup.update(m.messageGroup.id, {
        lastMessage: m.id,
        schollSideLastSeen: moment().toISOString()
      })

      const messages = [...state.messages, m]
      commit('changeState', { messages })
      return m
    },
    uploadImage({ commit }, formData) {
      return axios
        .post(UPLOAD_API, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          commit('setImage', response[0])
          return response[0]
        })
    },
    async addManagerToMessageGroup({ commit, state }, { id, ...data }) {
      MessageGroup.update(id, data)
      const m = await Message.create({
        messageGroup: id,
        time: moment().toISOString(),
        content: 'BGH nhà trường đã được bổ sung và phản hồi',
        data: { type: 'other' }
      })
      const messages = [...state.messages, m]
      commit('changeState', { messages })
    },
    async removeManagerToMessageGroup({ commit, state }, { id, ...data }) {
      MessageGroup.update(id, data)
      const m = await Message.create({
        messageGroup: id,
        time: moment().toISOString(),
        content: 'Đã xóa BGH nhà trường khỏi phản hồi',
        data: { type: 'other' }
      })
      const messages = [...state.messages, m]
      commit('changeState', { messages })
    },
    async searchMessageGroups({ commit }, query) {
      const messageGroups = await MessageGroup.fetch(query)
      commit('changeState', { messageGroups })
      return messageGroups
    }
  },
  mutations: {
    setImage(state, image) {
      const messages = state.messages.map(m => {
        if (m.id === image.related[0].id) {
          const mess = { ...m, image }
          return mess
        } else {
          return m
        }
      })

      state.messages = messages
    }
  },
  getters: {
    messageGroups: state => {
      let groups = [...state.messageGroups]
      groups = groups.map(g => {
        if (g.schollSideLastSeen && g.lastMessage && moment(g.schollSideLastSeen).isBefore(moment(g.lastMessageTime))) {
          g['hasUnreadMessage'] = true
        } else {
          g['hasUnreadMessage'] = false
        }

        if (g.id === state.messageGroup.id) {
          g.selected = true
        } else {
          g.selected = false
        }

        return g
      })

      return groups
    }
  }
}
